import React from "react";
import styles from "./action_btn.module.css";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "main/shared/helpers";
import { useParams } from "react-router-dom";
import {
  getReportDataActionCTA,
  publishRemediationDataAction,
  saveRemediationDataAction,
} from "store/actions/remediation_priorities_document/remediationPrioritiesDocumentAction";

const ActionButton = (props) => {
  const { selectedFilters, testResultsOpen } = props;
  const { insp_id } = useParams();

  const dispatch = useDispatch();
  const remediationPrioritiesDocument = useSelector(
    (state) => state.remediationPrioritiesDocument
  );
  const { reportData } = remediationPrioritiesDocument;

  const handleOnReload = async () => {
    try {
      dispatch(getReportDataActionCTA(insp_id, reportData));
      showToast("Got all Changes Successfully", true);
    } catch (e) {
      showToast(e?.message);
    }
  };

  const handleOnSave = async () => {
    try {
      await dispatch(saveRemediationDataAction(insp_id));
      showToast("Report Saved Successfully", true);
      setTimeout(() => {
        dispatch(getReportDataActionCTA(insp_id, reportData));
      }, 1000);
    } catch (e) {
      showToast(e?.message);
    }
  };

  const handlePublish = async () => {
    try {
      dispatch(publishRemediationDataAction(insp_id, selectedFilters));
      setTimeout(() => {
        dispatch(getReportDataActionCTA(insp_id, reportData));
      }, 1000);
      showToast("Report Published Successfully", true);
    } catch (e) {
      showToast(e?.message);
    }
  };

  return (
    <div
      className={`${styles.container} ${testResultsOpen ? styles.toggled : ""}`}
    >
      <div className={styles.action_buttons}>
        <Button onClick={handleOnSave} className={styles.save_btn} size="sm">
          Save
        </Button>
        <Button
          onClick={handleOnReload}
          className={styles.refresh_btn}
          size="sm"
        >
          Reload
        </Button>
        <Button
          onClick={handlePublish}
          className={styles.publish_btn}
          size="sm"
        >
          Publish
        </Button>
        {/* <Dropdown className={styles.dropDownCnt}>
          <Dropdown.Toggle
            className={styles.publish_btn}
            size="sm"
            id="dropdown-basic"
          >
            Publish
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              className="custom-dropdown-item"
              onClick={() => handlePublish("full")}
            >
              Receipt
            </Dropdown.Item>
            <Dropdown.Item
              className="custom-dropdown-item"
              onClick={() => handlePublish("half")}
            >
              Invoice
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}
      </div>
    </div>
  );
};

export default ActionButton;
